export default {
  subtotal: 'Suma częściowa',
  tip: 'Napiwek',
  discount: 'Rabat',
  method_fee: 'Opłata za dostawę',
  service_fee: {
    title: 'Opłata serwisowa',
    description:
      'Ta niewielka opłata serwisowa pomaga nam pokryć koszty związane z każdym zamówieniem — takie jak wysyłanie SMS-ów o statusie zamówienia, utrzymanie platformy online i dodatkowe opłaty transakcyjne. Jest ona znacznie niższa niż na aplikacjach dostawczych. Dziękujemy za zrozumienie i bezpośrednie wsparcie!',
  },
  payment_method_upcharge_fee: {
    title: 'Opłata PayPal',
    description:
      'Za każdą płatność przez PayPal pobiera on opłatę w wysokości 6–7%. Przy 100€ tracimy 6–7€. Dlatego niestety musimy doliczyć dopłatę 3,5% za korzystanie z PayPal. 🤯 Rozważ użycie innej bezpiecznej metody płatności. Jesteśmy bardzo wdzięczni za Twoje zrozumienie i wsparcie! 🙏',
  },
  tax: 'Podatki',
  total: 'Łącznie',
  earned_points: 'Zdobyłeś {{points}} punktów',
};
